// src/pages/ContactUs.tsx
import React, { useEffect } from "react";

export default function ContactUs() {
  useEffect(() => {
    document.title = "Contact Us • Backlink Banana";
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-blue-700 mb-6 text-center">
        Contact Us
      </h1>
      <p className="text-gray-700 mb-6 text-center">
        Have questions or feedback? mail us at support@backlinkbanana.com or fill out the form below and we’ll get back to you shortly.
      </p>
      <div className="flex justify-center">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSf6zYj22Bv_0heHnyQA3yMT4ayMiblj4FzIJ109H30oswmBYg/viewform?embedded=true"
          width="100%"
          height="720"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          title="Contact Us Form"
          className="w-full max-w-2xl"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}
